import type {
  TemplateViewsGroupedByDate,
  TemplateViewsGroupedByMarket
} from '../SpecialsTemplatePanel';

export const isTemplateViewsGroupedByDate = (
  group: TemplateViewsGroupedByDate | TemplateViewsGroupedByMarket
): group is TemplateViewsGroupedByDate => Array.isArray(group[0]);
